<template>
    <div class="loginform">
        <div class="call-button-container">
            <h1 class="loginform__header">Авторизация</h1>
            <b-alert :show="error.show" variant="danger">{{ error.message }}</b-alert>
            <b-form @submit="submitLoginForm">
                <b-form-input
                        type="text"
                        placeholder="Логин"
                        class="loginform__item"
                        v-model="login"
                        @blur="onBlur"
                ></b-form-input>
                <b-form-input
                        type="password"
                        placeholder="Пароль"
                        class="loginform__item"
                        v-model="password"
                        @blur="onBlur"
                ></b-form-input>
                <b-button block type="submit" variant="success">
                    Войти
                    <b-spinner v-if="spinner" type="grow" label="Loading..." small></b-spinner>
                </b-button>
            </b-form>
        </div>
    </div>
</template>

<script>
    import { v4 } from 'uuid';
    export default {
        name: "Login",
        data: () => ({
            spinner: false,
            error: {
                show: false,
                message: '',
            },
            login: '',
            password: '',
        }),
        methods: {
            submitLoginForm(evt) {
                evt.preventDefault();
                // Валидация
                if (!this.login.trim().length || !this.password.trim().length) {
                    this.error.message = 'Не указан логин/пароль!';
                    this.error.show = true;
                    return;
                }

                this.spinner = true;
                this.error.show = false;
                let deviceId = localStorage.getItem('deviceId');
                if (!deviceId) {
                    deviceId = v4();
                    localStorage.setItem('deviceId', deviceId);
                }
                this.$http.post(`${process.env.VUE_APP_API_HOST}/admin/auth/signIn`, {
                    login: this.login.trim(),
                    password: this.password.trim(),
                    deviceId,
                })
                    .then((data) => {
                        console.log('123');
                        this.spinner = false;
                        const resData = data.data.data;
                        if (!resData.accessToken || !resData.refreshToken) {
                            this.password = '';
                            this.error.message = 'Ошибка авторизации';
                            this.error.show = true;
                            console.error('Invalid server response!');
                            return;
                        }
                        localStorage.setItem('jwt', resData.accessToken);
                        localStorage.setItem('refresh', resData.refreshToken);
                        this.$router.push({ name: 'home' });
                    })
                    .catch((err) => {
                        console.log(err.message);
                        this.password = '';
                        if (err.response) {
                            this.error.message = 'Неверный логин/пароль';
                        } else {
                            console.error(err);
                            this.error.message = 'Ошибка авторизации';
                        }
                        this.spinner = false;
                        this.error.show = true;
                    });
            },
            onBlur(ev) {
                ev.target.value = ev.target.value.trim();
            }
        },
    }
</script>

<style scoped>
    .loginform {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
    }

    .loginform__header {
        color: #585858;
        margin-bottom: 30px;
    }

    .loginform__item {
        margin-bottom: 10px;
    }
</style>